module.exports = __webpack_public_path__ + "fonts/subset-MullerThinItalic.a55766f9.woff2";